import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { encrypt } from '../crypto'
import { setUser } from '../redux/Slices/UserSlice';
import NavbarMob from '../components/NavbarMob';
import Navbar from '../components/Navbar';
import FooterMob from '../components/FooterMob';
import Footer from '../components/Footer';
import OrderSuccess from '../components/OrderSuccess';
import deleteicon from '../images/Cart/Bin.png'
import axios from 'axios'
import { useStore } from '../useStore';
import { shortEncrypt } from "../crypto";
import logo from '../images/Navbar/logo.png'
import CryptoJS from "crypto-js";

function Cart() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);
    const [addError, setAddError] = useState(false)

    // console.log(cartItems, 'cartItems');


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [address, setAddress] = useState(null);
    const [productDetails, setProductDetails] = useState({}); // To store color and size for each uniqueCode
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [loginMode, setLoginMode] = useState('otp'); // password | otp
    const [loginMobile, setLoginMobile] = useState('');
    const [loginOtp, setLoginOtp] = useState('');
    const [loginOtpSession, setLoginOtpSession] = useState('');
    const [loginOtpStatus, setLoginOtpStatus] = useState('');
    const [authTab, setAuthTab] = useState('login'); // login | signup
    const [signupMode, setSignupMode] = useState('mobile'); // email | mobile
    const [signupEmail, setSignupEmail] = useState('');
    const [signupMobile, setSignupMobile] = useState('');
    const [signupName, setSignupName] = useState('');
    const [signupPassword, setSignupPassword] = useState('');
    const [signupLoading, setSignupLoading] = useState(false);
    const [signupOtpSession, setSignupOtpSession] = useState('');
    const [signupOtp, setSignupOtp] = useState('');
    const [signupOtpStatus, setSignupOtpStatus] = useState('');
    const [signupIsOtpStep, setSignupIsOtpStep] = useState(false);
    const [signupInputType, setSignupInputType] = useState('');
    const [signupIdentifier, setSignupIdentifier] = useState('');
    const [registeredEmail, setRegisteredEmail] = useState('');
    const [emailEditorOpen, setEmailEditorOpen] = useState(false);
    const [newEmailInput, setNewEmailInput] = useState('');
    const [emailOtpInput, setEmailOtpInput] = useState('');
    const [emailOtpSent, setEmailOtpSent] = useState(false);
    const [emailUpdateLoading, setEmailUpdateLoading] = useState(false);
    const dispatch = useDispatch();

    // console.log(address, 'address');


    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const apiRazorpayUrl = process.env.REACT_APP_API_SERVER_URL;
    const apiWhatsappUrl = process.env.REACT_APP_API_WHATSAPP;
    const whatsappAppKey = process.env.REACT_APP_WHATSAPP_APP_KEY;
    const whatsappAuthKey = process.env.REACT_APP_WHATSAPP_AUTH_KEY;
    const razorpayCheckoutKey = process.env.REACT_APP_RAZORPAY_KEY_ID;


    const userId = useSelector((state) => state.user.id);
    const LedCode = localStorage.getItem('LedCode');
    const currentUserId = LedCode || userId;
    const TRACK_SECRET_KEY = "shersoft_blackbaton_delhivery";
    const encryptTrackOrderId = (text) => CryptoJS.AES.encrypt(String(text), TRACK_SECRET_KEY).toString();

    const fetchCustomerDataById = async () => {
        if (!currentUserId) return null;
        try {
            const response = await axios.get(`${apiBaseUrl}/user/getCustomerById/BLACKBATON_2526/${currentUserId}`);
            if (response?.data?.success) {
                return response.data.data;
            }
        } catch (err) {
            console.error('Error fetching customer data:', err);
        }
        return null;
    };

    // const checkDelhiveryServiceability = async (pincode) => {
    //     try {
    //         const normalizedPin = String(pincode || '').trim();
    //         const yesValues = new Set(['Y', 'YES', 'TRUE', '1', 'T']);
    //         const isYes = (value) => yesValues.has(String(value ?? '').trim().toUpperCase());

    //         if (!/^\d{6}$/.test(normalizedPin)) {
    //             return {
    //                 serviceable: false,
    //                 isPrepaid: false,
    //                 isCod: false,
    //                 message: "Enter a valid 6-digit pincode"
    //             };
    //         }

    //         const res = await fetch(`${apiBaseUrl}/delhivery-pincode/${normalizedPin}`);
    //         const result = await res.json();

    //         if (!res.ok || !result?.success) {
    //             return {
    //                 serviceable: false,
    //                 isPrepaid: false,
    //                 isCod: false,
    //                 message: "Unable to verify Delhivery serviceability now. Please try again."
    //             };
    //         }

    //         const deliveryCodes = result?.data?.delivery_codes || [];
    //         const matchedDeliveryCode = deliveryCodes.find((code) => {
    //             const postal = code?.postal_code || {};
    //             const apiPin = String(
    //                 postal.pin ||
    //                 postal.pincode ||
    //                 postal.postcode ||
    //                 ''
    //             ).trim();
    //             return apiPin === normalizedPin;
    //         });

    //         if (!matchedDeliveryCode) {
    //             return {
    //                 serviceable: false,
    //                 isPrepaid: false,
    //                 isCod: false,
    //                 message: `Pincode ${normalizedPin} is not serviceable by Delhivery.`
    //             };
    //         }

    //         const pinInfo = matchedDeliveryCode?.postal_code;
    //         const isPrepaid = isYes(pinInfo?.pre_paid);
    //         const isCod = isYes(pinInfo?.cod);
    //         const canDeliver = isYes(pinInfo?.delivery ?? 'Y'); // Default to Y if missing, but check if NO

    //         const noValues = new Set(['N', 'NO', 'FALSE', '0', 'F']);
    //         const isNo = (value) => noValues.has(String(value ?? '').trim().toUpperCase());

    //         const isSurfaceDisabled = isNo(pinInfo?.is_surface) || isNo(pinInfo?.surface);
    //         const isExpressEnabled = isYes(pinInfo?.is_express) || isYes(pinInfo?.express);
    //         const isDeliveryDisabled = isNo(pinInfo?.delivery);

    //         const hasSortCode = Boolean(
    //             pinInfo?.sort_code ||
    //             matchedDeliveryCode?.sort_code ||
    //             pinInfo?.sortcode
    //         );
    //         const explicitServiceable = pinInfo?.serviceable ?? matchedDeliveryCode?.serviceable;
    //         const hasExplicitServiceableFlag = !(explicitServiceable === undefined || explicitServiceable === null || explicitServiceable === '');
    //         const serviceableByFlag = hasExplicitServiceableFlag ? isYes(explicitServiceable) : true;

    //         // Allow if either Surface or Express is available
    //         const serviceable = Boolean(pinInfo && serviceableByFlag && hasSortCode && (isPrepaid || isCod) && (!isSurfaceDisabled || isExpressEnabled) && !isDeliveryDisabled);

    //         if (!serviceable) {
    //             let reason = `Pincode ${normalizedPin} is not serviceable by Delhivery.`;
    //             if (isSurfaceDisabled && isExpressEnabled) {
    //                 reason = `Pincode ${normalizedPin} is only serviceable via Express. Currently, only Surface delivery is supported.`;
    //             } else if (isDeliveryDisabled) {
    //                 reason = `Delhivery has disabled deliveries to pincode ${normalizedPin} at this time.`;
    //             } else if (!isPrepaid && !isCod) {
    //                 reason = `Pincode ${normalizedPin} is not accepting Prepaid or COD shipments.`;
    //             } else if (!hasSortCode) {
    //                 reason = `Pincode ${normalizedPin} is missing routing data (Sort Code).`;
    //             }

    //             return {
    //                 serviceable: false,
    //                 isPrepaid,
    //                 isCod,
    //                 message: reason
    //             };
    //         }

    //         if (!isPrepaid) {
    //             return {
    //                 serviceable: true,
    //                 isPrepaid: false,
    //                 isCod,
    //                 message: `Prepaid delivery is not available for pincode ${normalizedPin}.`
    //             };
    //         }

    //         return {
    //             serviceable: true,
    //             isPrepaid,
    //             isCod,
    //             message: ""
    //         };
    //     } catch (error) {
    //         console.error('Delhivery pincode validation failed:', error);
    //         return {
    //             serviceable: false,
    //             isPrepaid: false,
    //             isCod: false,
    //             message: "Unable to verify Delhivery serviceability now. Please try again."
    //         };
    //     }
    // };

    // Fetch product details (color and size) by uniqueCode


    const checkDelhiveryServiceability = async (pincode) => {
        try {
            const normalizedPin = String(pincode || '').trim();

            if (!/^\d{6}$/.test(normalizedPin)) {
                return {
                    serviceable: false,
                    isPrepaid: false,
                    isCod: false,
                    shippingMode: null,
                    message: "Enter a valid 6-digit pincode"
                };
            }

            const res = await fetch(`${apiBaseUrl}/delhivery-pincode/${normalizedPin}`);
            const result = await res.json();

            if (!res.ok || !result?.success) {
                return {
                    serviceable: false,
                    isPrepaid: false,
                    isCod: false,
                    shippingMode: null,
                    message: "Unable to verify serviceability"
                };
            }

            const pinInfo = result?.data?.delivery_codes?.[0]?.postal_code;

            if (!pinInfo) {
                return {
                    serviceable: false,
                    isPrepaid: false,
                    isCod: false,
                    shippingMode: null,
                    message: "Pincode not serviceable"
                };
            }

            const yes = (v) => ['Y', 'YES', 'TRUE', '1'].includes(String(v).toUpperCase());
            const no = (v) => ['N', 'NO', 'FALSE', '0'].includes(String(v).toUpperCase());

            const isPrepaid = yes(pinInfo.pre_paid);
            const isCod = yes(pinInfo.cod);
            const isSurfaceDisabled = no(pinInfo.is_surface) || no(pinInfo.surface);
            const isExpressEnabled = yes(pinInfo.is_express) || yes(pinInfo.express);
            const isDeliveryDisabled = no(pinInfo.delivery);

            if (isDeliveryDisabled) {
                return {
                    serviceable: false,
                    isPrepaid,
                    isCod,
                    shippingMode: null,
                    message: "Delivery not available"
                };
            }

            let shippingMode = "Surface";

            // 🔥 MAIN FIX
            if (isSurfaceDisabled && isExpressEnabled) {
                shippingMode = "Express";
            }

            return {
                serviceable: true,
                isPrepaid,
                isCod,
                shippingMode,
                message: ""
            };

        } catch (error) {
            return {
                serviceable: false,
                isPrepaid: false,
                isCod: false,
                shippingMode: null,
                message: "Error checking pincode"
            };
        }
    };

    const fetchProductDetails = async (uniqueCode) => {
        try {
            const response = await fetch(
                `${apiBaseUrl}/getProductByUniqueCode/BLACKBATON_2526?uniqueCode=${uniqueCode}`
            );
            if (!response.ok) {
                throw new Error('Failed to fetch product details');
            }
            const data = await response.json();
            if (data.length > 0) {
                return data[0]; // Return the first item (color and size)
            }
            return null;
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };

    const { showDropdown, setShowDropdown } = useStore()

    // Fetch cart items
    useEffect(() => {
        const remembered = localStorage.getItem('rememberedIdentifier');
        if (remembered) {
            setLoginEmail(remembered);
            setRememberMe(true);
        }
    }, []);

    useEffect(() => {
        const loadRegisteredEmail = async () => {
            const data = await fetchCustomerDataById();
            const email = String(data?.email || '').trim();
            setRegisteredEmail(email);
        };
        loadRegisteredEmail();
    }, [currentUserId, apiBaseUrl]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchCartItems = async () => {
            try {
                const ledCodeOrUserId = LedCode || userId;
                let finalItems = [];

                if (!ledCodeOrUserId) {
                    // Guest User: Load from localStorage
                    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                    finalItems = guestCart;
                } else {
                    // Authenticated User: Fetch from DB and check for guest cart to merge
                    const response = await fetch(
                        `${apiBaseUrl}/cart/items/BLACKBATON_2526/${ledCodeOrUserId}`
                    );
                    const data = await response.json();
                    let dbItems = (data.success && data.items) ? data.items : [];

                    // Check for guest cart to merge
                    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                    if (guestCart.length > 0) {
                        try {
                            const currentLoginId = localStorage.getItem('loginId') || ledCodeOrUserId;
                            const currentLoginName = localStorage.getItem('loginName') || 'User';

                            // Merge guest items into DB
                            const guestCartToMerge = guestCart.map(item => ({
                                ...item,
                                ledcode: currentLoginId,
                                ledname: currentLoginName,
                                ledemail: localStorage.getItem('loginEmail') || ''
                            }));

                            // Clear guest cart BEFORE merge API call to prevent re-triggering while in flight
                            localStorage.removeItem('guestCart');

                            const mergeRes = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(guestCartToMerge),
                            });

                            if (mergeRes.ok) {
                                // Guest cart already removed above
                                const refreshedRes = await fetch(
                                    `${apiBaseUrl}/cart/items/BLACKBATON_2526/${ledCodeOrUserId}`
                                );
                                const refreshedData = await refreshedRes.json();
                                dbItems = (refreshedData.success && refreshedData.items) ? refreshedData.items : [];
                            } else {
                                // If merge failed, we might want to restore the guest cart or handle error
                                console.error('Failed to merge guest cart into DB');
                            }
                        } catch (mergeErr) {
                            console.error('Error merging guest cart:', mergeErr);
                        }
                    }
                    finalItems = dbItems;
                }

                setCartItems(finalItems);

                if (finalItems.length > 0) {
                    // Fetch product details for each item
                    const details = {};
                    for (const item of finalItems) {
                        const productInfo = await fetchProductDetails(item.uniqueCode);
                        if (productInfo) {
                            details[item.uniqueCode] = {
                                color: productInfo.Color,
                                size: productInfo.Size,
                            };
                        }
                    }
                    setProductDetails(details);
                }
            } catch (error) {
                setError(error.message);
                setCartItems([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCartItems();
    }, [LedCode, userId, apiBaseUrl]);

    const handleQuantityChange = async (identifier, newQuantity) => {
        try {
            // Prevent quantity from going below 1
            if (newQuantity < 1) {
                toast.info('Quantity cannot be less than 1');
                return;
            }

            // Find the item in the cartItems array using sino or uniqueCode
            const itemToUpdate = cartItems.find((item) => item.sino === identifier || item.uniqueCode === identifier);

            if (!itemToUpdate) {
                console.error("Item not found for identifier:", identifier);
                return;
            }

            // Calculate the difference between the new quantity and the current quantity
            const quantityDifference = newQuantity - itemToUpdate.quantity;

            if (!LedCode && !userId) {
                // Guest User update
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                const updatedGuestCart = guestCart.map(item =>
                    item.uniqueCode === itemToUpdate.uniqueCode
                        ? { ...item, quantity: newQuantity }
                        : item
                );
                localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
                setCartItems(updatedGuestCart);
                return;
            }

            // Send API request to update quantity in the backend
            const response = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify([{
                    itemId: itemToUpdate.itemId,
                    uniqueCode: itemToUpdate.uniqueCode,
                    itemName: itemToUpdate.itemName,
                    itemPrice: itemToUpdate.itemPrice,
                    quantity: quantityDifference, // Send the difference, not the new quantity
                    ledname: itemToUpdate.ledname,
                    ledcode: itemToUpdate.ledcode,
                    ledemail: itemToUpdate.ledemail,
                }]),
            });

            if (!response.ok) {
                throw new Error('Failed to update quantity');
            }

            const data = await response.json();
            //('Quantity updated successfully:', data);

            // Update the cartItems state only after the API call succeeds
            const updatedCartItems = cartItems.map((item) =>
                (item.sino === identifier || item.uniqueCode === identifier) ? { ...item, quantity: newQuantity } : item
            );
            setCartItems(updatedCartItems);
        } catch (error) {
            console.error('Error updating quantity:', error);
            toast.info('Failed to update quantity. Please try again.');
        }
    };

    const [modifiedColors, setModifiedColors] = useState([])

    // console.log(modifiedColors,'modifiedColors');

    useEffect(() => {
        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data,'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };
        fetchModfiedColors()
    }, [])

    useEffect(() => {
        const fetchAddress = async () => {


            try {
                const ledCodeOrUserId = LedCode || userId;

                //("Fetching Cart Items for:", ledCodeOrUserId);
                const response = await fetch(`${apiBaseUrl}/user/getAddresses/BLACKBATON_2526/${ledCodeOrUserId}`);
                const data = await response.json();

                if (data.success && data.data.length > 0) {
                    const existingActiveAddress = data.data.find(addr => addr.isActive);
                    // Prefer active address; fallback to first saved address.
                    const activeAddress = existingActiveAddress || data.data[0];

                    if (!activeAddress) {
                        setAddress(null);
                        return;
                    }

                    if (!existingActiveAddress) {
                        try {
                            await fetch(`${apiBaseUrl}/user/setActiveAddress`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    addressId: activeAddress.id,
                                    ledcode: ledCodeOrUserId
                                })
                            });
                        } catch (setActiveErr) {
                            console.error('Error auto-setting active address:', setActiveErr);
                        }
                    }

                    const pinValidation = await checkDelhiveryServiceability(activeAddress.pincode);

                    // Add pre_paid field to address state
                    setAddress({
                        ...activeAddress,
                        pre_paid: pinValidation.isPrepaid,
                        cod: pinValidation.isCod,
                        delhivery_serviceable: pinValidation.serviceable
                    });

                }
            } catch (error) {
                console.error('Error fetching address:', error);
            }
        };

        fetchAddress();
    }, [LedCode, apiBaseUrl, userId]);

    const addresspage = () => {
        if (!LedCode && !userId) {
            setIsLoginModalOpen(true);
            return;
        }
        navigate('/address');
    };

    const wishlistpage = () => {
        navigate('/wishlist')
    }

    const openProductFromCart = (item) => {
        if (!item?.itemId || !item?.itemName) return;
        navigate(`/fullimage?I=${btoa(String(item.itemId))}&N=${btoa(item.itemName)}`);
    };



    // if (loading) {
    //     return <div>Loading...</div>;
    // }

    if (error) {
        return <div>Error: {error}</div>;
    }

    // const handleSendToWhatsapp = async (url, payload, number) => {
    //     const requestId = Date.now() + Math.random();
    //     try {
    //         console.log(`Sending request ${requestId} to ${url} with payload:`, payload);
    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ ...payload, requestId }),
    //         });
    //         const data = await response.json();
    //         console.log(`Response for request ${requestId} from ${url} for ${number}:`, {
    //             status: response.status,
    //             data,
    //         });
    //         return {
    //             to: number,
    //             success: response.ok && data.success !== false,
    //             message:
    //                 data.message || (response.ok ? "Message sent successfully" : `Failed: ${response.statusText}`),
    //             type,
    //         };
    //     } catch (error) {
    //         console.error(`Error for request ${requestId} sending to ${url} for ${number}:`, error);
    //         return {
    //             to: number,
    //             success: false,
    //             message: error.message || `Network error sending to ${number}`,
    //             type,
    //         };
    //     }
    // };

    // console.log(cartItems, 'cartItems');

    function encodeBase64(text) {
        return btoa(text);
    }


    const handleSubmitWhatsapp = async (orderMeta = {}) => {

        try {


            const ledName = address.name || "Customer";
            const now = new Date();

            const cDate = now.toLocaleDateString("en-GB");
            const cTime = now.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });

            const groupedData = Object.values(
                cartItems.reduce((acc, item) => {

                    const color = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || [];
                    const modifiedColor = modifiedColors[color]?.name;
                    const size = productDetails[item.uniqueCode]?.size || "N/A";

                    // If itemName is not present, create base object
                    if (!acc[item.itemName]) {
                        acc[item.itemName] = {
                            itemId: item.itemId,
                            itemName: item.itemName,
                            itemPrice: item.itemPrice,
                            size: {}   //  create size object
                        };
                    }

                    // If size group does not exist, create it
                    if (!acc[item.itemName].size[size]) {
                        acc[item.itemName].size[size] = [];
                    }

                    // Push item details under correct size
                    acc[item.itemName].size[size].push({
                        quantity: item.quantity,
                        sino: item.sino,
                        uniqueCode: item.uniqueCode,
                        color: modifiedColor || color
                    });

                    return acc;
                }, {})
            );


            let message = `Ⓑ *𝗕𝗟𝗔𝗖𝗞𝗕𝗔𝗧𝗢𝗡*\n✔️ Order Confirmed\n\nDate: ${cDate} ${cTime}\n`;

            if (address.name) {
                message += `Customer : *${ledName}*\n`;
            }
            if (address.mobile) {
                message += `Mobile : *${address.mobile}*\n`;
            }
            if (address.address) {
                message += `Address : ${address.address}\n`;
            }

            let totalAmount = 0; // GRAND TOTAL

            groupedData.forEach(itemGroup => {
                let itemTotalAmount = 0; //  TOTAL FOR EACH ITEM NAME

                const link = `www.blackbaton.com/${shortEncrypt('fullimage')}?I=${encodeBase64(String(itemGroup.itemId))}&N=${encodeBase64(itemGroup.itemName)}`

                message += '\n⤷ ';
                message += '`';
                message += `${link}`;
                message += '`';
                message += '\n';
                message += `*${itemGroup.itemName}*\n`;

                // STEP 1: Build color-size map
                const colorSizeMap = {};

                Object.entries(itemGroup.size).forEach(([size, items]) => {
                    items.forEach(d => {
                        const color = d.color || "N/A";

                        if (!colorSizeMap[color]) {
                            colorSizeMap[color] = {};
                        }

                        if (!colorSizeMap[color][size]) {
                            colorSizeMap[color][size] = 0;
                        }

                        colorSizeMap[color][size] += d.quantity;
                    });
                });

                // STEP 2: Build WhatsApp lines (color : sizes)
                Object.entries(colorSizeMap).forEach(([color, sizes]) => {

                    const sizeString = Object.entries(sizes)
                        .map(([size, qty]) => {

                            const lineTotal = itemGroup.itemPrice * qty;

                            //  add to item total
                            itemTotalAmount += lineTotal;

                            //  add to grand total
                            totalAmount += lineTotal;

                            return `${size} - ${qty}`;   //  FIXED (you forgot return)
                        })
                        .join(', ');

                    message += `* ${color} : ${sizeString}\n`;
                });

                // Show item total
                message += `*Total :* ₹${itemTotalAmount.toFixed(2)}\n`;
            });

            message += `\n----------------------------\n💰 *Grand Total : ₹${totalAmount.toFixed(2)}*`;

            // console.log(address.mobile, 'address.mobile');
            const normalizeMobile = (num) => {
                if (!num) return "";

                // Convert to string & trim spaces
                num = String(num).trim();

                // Remove all non-digits (if any)
                num = num.replace(/\D/g, "");

                // If number starts with 0 → remove that 0
                if (num.startsWith("0")) {
                    num = num.substring(1);
                }

                // Now ensure it starts with 91
                if (!num.startsWith("91")) {
                    num = "91" + num;
                }

                return num;
            };

            const finalMobile = normalizeMobile(address.mobile);

            // console.log(finalMobile, 'finalMobile');



            try {
                const response = await axios.post(`${apiWhatsappUrl}/send-message`, {
                    // userId: 'BLACKBATON',
                    appkey: whatsappAppKey,
                    authkey: whatsappAuthKey,
                    to: finalMobile,
                    message: message
                });

            } catch (error) {
                console.error('Error sending WhatsApp message:', error);
                // toast.info('An error occurred while sending the message. Please try again.');
            } finally {
                try {
                    const response = await axios.post(`${apiWhatsappUrl}/send-group`, {
                        // userId: 'BLACKBATON',
                        appkey: whatsappAppKey,
                        authkey: whatsappAuthKey,
                        groupName: "Website orders details",
                        // groupName: "Test",
                        message: message
                    });

                } catch (error) {
                    console.error('Error sending WhatsApp message:', error);
                    // toast.info('An error occurred while sending the message. Please try again.');
                }
            }

            const latestCustomer = await fetchCustomerDataById();
            const mailFromDb = String(latestCustomer?.email || registeredEmail || '').trim();
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mailFromDb);
            if (isValidEmail) {
                try {
                    const totalAmountValue = cartItems.reduce(
                        (sum, item) => sum + (Number(item.itemPrice || 0) * Number(item.quantity || 0)),
                        0
                    );
                    const isSingleItem = cartItems.length === 1;
                    const single = isSingleItem ? cartItems[0] : null;
                    const singleColorText = single
                        ? (modifiedColors[productDetails[single.uniqueCode]?.color]?.name || productDetails[single.uniqueCode]?.color || 'N/A')
                        : null;
                    const singleSize = single ? (productDetails[single.uniqueCode]?.size || 'N/A') : null;
                    const singleColorCode = single
                        ? (modifiedColors[productDetails[single.uniqueCode]?.color]?.name || [])
                        : [];
                    const singleCode = single ? `${single.itemId}_${singleColorCode}` : '';
                    const singleImageUrl = single ? `${apiLocalUrl}/uploads/${singleCode}.webp` : null;
                    const plainOrderId = orderMeta?.orderId ? String(orderMeta.orderId) : "";
                    const encryptedOrderId = plainOrderId ? encodeURIComponent(encryptTrackOrderId(plainOrderId)) : "";
                    const trackUrl = `${window.location.origin}/delhiverytracking?i=${encryptedOrderId}`;
                    const orderItems = cartItems.map((item) => {
                        const colorText = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || productDetails[item.uniqueCode]?.color || 'N/A';
                        const sizeText = productDetails[item.uniqueCode]?.size || 'N/A';
                        const colorCode = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || [];
                        const code = `${item.itemId}_${colorCode}`;
                        return {
                            name: item.itemName,
                            color: colorText,
                            size: sizeText,
                            quantity: item.quantity,
                            imageUrl: `${apiLocalUrl}/uploads/${code}.webp`
                        };
                    });

                    await axios.post(`${apiRazorpayUrl}/send-order-confirmation-email`, {
                        to: mailFromDb,
                        subject: 'Order Confirmed | BLACKBATON',
                        message,
                        orderId: plainOrderId,
                        totalAmount: totalAmountValue.toFixed(2),
                        userName: address?.name || localStorage.getItem('loginName') || 'Customer',
                        trackUrl,
                        itemCount: cartItems.length,
                        orderItems,
                        singleItem: isSingleItem ? {
                            name: single?.itemName,
                            color: singleColorText,
                            size: singleSize,
                            quantity: single?.quantity,
                            imageUrl: singleImageUrl
                        } : null
                    });
                } catch (mailErr) {
                    console.error('Error sending order confirmation email:', mailErr);
                }
            }


        } catch (err) {
            console.error(err);
        }
    };

    const handleSendEmailOtp = async () => {
        if (!currentUserId) {
            toast.error('Please login first');
            return;
        }
        const email = String(newEmailInput || '').trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            toast.error('Enter a valid email');
            return;
        }

        try {
            setEmailUpdateLoading(true);
            const response = await axios.post(
                `${apiBaseUrl}/user/changeEmail/BLACKBATON_2526/${currentUserId}/${encodeURIComponent(email)}`
            );
            if (response?.data?.success) {
                setEmailOtpSent(true);
                toast.success('OTP sent to email');
            } else {
                toast.error(response?.data?.error || 'Failed to send OTP');
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || 'Failed to send OTP');
        } finally {
            setEmailUpdateLoading(false);
        }
    };

    const handleVerifyEmailOtp = async () => {
        const email = String(newEmailInput || '').trim();
        const otp = String(emailOtpInput || '').trim();
        if (!email || !otp) {
            toast.error('Enter email and OTP');
            return;
        }
        try {
            setEmailUpdateLoading(true);
            const response = await axios.post(`${apiBaseUrl}/user/verifyEmailOtp`, {
                cId: 'BLACKBATON_2526',
                id: currentUserId,
                email,
                otp
            });
            if (response?.data?.success) {
                setRegisteredEmail(email);
                setEmailEditorOpen(false);
                setEmailOtpSent(false);
                setNewEmailInput('');
                setEmailOtpInput('');
                toast.success('Email updated successfully');
            } else {
                toast.error(response?.data?.error || 'OTP verification failed');
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || 'OTP verification failed');
        } finally {
            setEmailUpdateLoading(false);
        }
    };




    const handleModalLogin = async (e) => {
        if (e) e.preventDefault();
        setLoginError("");
        try {
            if (!loginEmail || !loginPassword) {
                setLoginError('Please enter both email/mobile and password');
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const mobilePattern = /^\d{10}$/;
            let isInput = '';

            if (emailPattern.test(loginEmail)) {
                isInput = 'email';
            } else if (mobilePattern.test(loginEmail)) {
                isInput = 'mobile';
            } else {
                setLoginError('Please enter a valid email or 10-digit mobile number');
                return;
            }

            const response = await axios.post(`${apiBaseUrl}/user/login/BLACKBATON_2526`, {
                identifier: loginEmail,
                password: loginPassword,
                type: isInput
            });

            if (response.data.success) {
                const userData = response.data.user;
                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name);
                localStorage.setItem('loginEmail', userData.email || '');
                localStorage.setItem('loginMobile', userData.mobile || '');
                localStorage.setItem('LedCode', userData.id);

                if (rememberMe) {
                    localStorage.setItem('rememberedIdentifier', loginEmail);
                } else {
                    localStorage.removeItem('rememberedIdentifier');
                }

                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                setIsLoginModalOpen(false);
                toast.success("Logged in successfully!");

                // Reload to refresh states properly
                window.location.reload();
            } else {
                setLoginError(response.data.error || 'Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setLoginError(err.response?.data?.error || 'An error occurred while logging in');
        }
    };

    const handleSendModalLoginOtp = async () => {
        setLoginError('');
        if (!loginMobile || !/^\d{10}$/.test(loginMobile)) {
            setLoginError('Enter a valid 10-digit mobile number');
            return;
        }
        try {
            const smsRes = await axios.post(`${apiBaseUrl}/user/sendLoginOtp/BLACKBATON_2526`, {
                mobile: loginMobile,
                channel: 'sms'
            });
            setLoginOtpSession(smsRes.data.sessionId);
            setLoginOtpStatus('OTP sent. Please verify.');
        } catch (smsErr) {
            try {
                const waRes = await axios.post(`${apiBaseUrl}/user/sendLoginOtp/BLACKBATON_2526`, {
                    mobile: loginMobile,
                    channel: 'whatsapp'
                });
                setLoginOtpSession(waRes.data.sessionId);
                setLoginOtpStatus('OTP sent. Please verify.');
            } catch (waErr) {
                console.error('OTP send error (SMS + WhatsApp):', smsErr, waErr);
                setLoginError('OTP service is currently unreachable. Please try again in a moment.');
            }
        }
    };

    const handleVerifyModalLoginOtp = async () => {
        setLoginError('');
        if (!loginOtpSession) {
            setLoginError('Request OTP first');
            return;
        }
        if (!loginOtp || loginOtp.length !== 6) {
            setLoginError('Enter 6-digit OTP');
            return;
        }
        try {
            const response = await axios.post(`${apiBaseUrl}/user/verifyLoginOtp/BLACKBATON_2526`, {
                sessionId: loginOtpSession,
                otp: loginOtp
            });

            if (response.data.success) {
                const userData = response.data.user;
                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name || '');
                localStorage.setItem('loginEmail', userData.email || '');
                localStorage.setItem('loginMobile', userData.mobile || '');
                localStorage.setItem('LedCode', userData.id);

                if (rememberMe) {
                    localStorage.setItem('rememberedIdentifier', loginMobile);
                } else {
                    localStorage.removeItem('rememberedIdentifier');
                }

                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                setIsLoginModalOpen(false);
                toast.success("Logged in successfully!");
                window.location.reload();
            } else {
                setLoginError(response.data.error || 'Invalid OTP');
            }
        } catch (err) {
            console.error('OTP verify error:', err);
            setLoginError(err.response?.data?.error || 'Failed to verify OTP');
        }
    };

    const resetSignupOtpState = () => {
        setSignupOtpSession('');
        setSignupOtp('');
        setSignupOtpStatus('');
        setSignupIsOtpStep(false);
        setSignupInputType('');
        setSignupIdentifier('');
    };

    const handleInlineSignup = async () => {
        setLoginError('');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobilePattern = /^\d{10}$/;
        const method = signupMode;
        const identifier = (method === 'email' ? signupEmail : signupMobile).trim();
        const isIdentifierEmail = emailPattern.test(identifier || '');
        const isIdentifierMobile = mobilePattern.test(identifier || '');
        const effectiveMethod = method === 'email' && isIdentifierMobile ? 'mobile' : method;

        if (!identifier) {
            setLoginError('Please fill required fields');
            return;
        }
        if (method === 'email' && !isIdentifierEmail && !isIdentifierMobile) {
            setLoginError('Enter valid email or 10-digit mobile');
            return;
        }
        if (method === 'mobile' && !isIdentifierMobile) {
            setLoginError('Enter valid 10-digit mobile');
            return;
        }
        if (method === 'email' && (!signupName || !signupPassword)) {
            setLoginError('Please enter name and password for email signup');
            return;
        }
        setSignupLoading(true);
        try {
            let hadTransportFailure = false;
            let signupPayload = effectiveMethod === 'email'
                ? {
                    email: identifier,
                    full_name: signupName,
                    password: signupPassword,
                    input_type: effectiveMethod
                }
            : {
                mobile: identifier,
                full_name: method === 'email' ? signupName : '',
                password: method === 'email' ? signupPassword : '',
                channel: 'sms',
                input_type: effectiveMethod
            };

            let response = await fetch(`${apiBaseUrl}/user/SignUp/BLACKBATON_2526`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(signupPayload)
            });
            let data = await response.json();

            if ((!response.ok || !data?.sessionId) && effectiveMethod === 'mobile') {
                signupPayload = { ...signupPayload, channel: 'whatsapp' };
                try {
                    response = await fetch(`${apiBaseUrl}/user/SignUp/BLACKBATON_2526`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(signupPayload)
                    });
                    data = await response.json();
                } catch (fallbackErr) {
                    hadTransportFailure = true;
                }
            }
            if (response.ok && data.sessionId) {
                setSignupOtpSession(data.sessionId);
                setSignupOtp('');
                setSignupOtpStatus('OTP sent. Please verify to continue.');
                setSignupIsOtpStep(true);
                setSignupInputType(effectiveMethod);
                setSignupIdentifier(identifier);
                toast.success('OTP sent. Please verify.');
            } else {
                setLoginError(
                    effectiveMethod === 'mobile' && hadTransportFailure
                        ? 'OTP service is currently unreachable. Please try again in a moment.'
                        : (data?.error || 'Registration failed')
                );
            }
        } catch (err) {
            console.error('Signup error:', err);
            setLoginError('Error creating account');
        } finally {
            setSignupLoading(false);
        }
    };

    const handleVerifyInlineSignupOtp = async () => {
        setLoginError('');

        if (!signupOtpSession) {
            setLoginError('Request OTP first');
            return;
        }

        if (!signupOtp || signupOtp.length !== 6) {
            setLoginError('Enter 6-digit OTP');
            return;
        }

        try {
            const verifyRes = await fetch(`${apiBaseUrl}/user/Verify/BLACKBATON_2526`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sessionId: signupOtpSession,
                    otp: signupOtp
                })
            });
            const verifyData = await verifyRes.json();

            if (!verifyRes.ok || !verifyData.success) {
                setLoginError(verifyData.error || 'Invalid OTP');
                return;
            }

            let userData = {
                id: verifyData.id,
                full_name: '',
                email: signupInputType === 'email' ? signupIdentifier : '',
                mobile: signupInputType === 'mobile' ? signupIdentifier : '',
                isAdmin: 0
            };

            try {
                const userRes = await fetch(`${apiBaseUrl}/user/getCustomerById/BLACKBATON_2526/${verifyData.id}`);
                const userJson = await userRes.json();
                if (userRes.ok && userJson.success && userJson.data) {
                    userData = {
                        ...userData,
                        ...userJson.data
                    };
                }
            } catch (userFetchErr) {
                console.error('Error fetching new user details:', userFetchErr);
            }

            localStorage.setItem('loginId', userData.id);
            localStorage.setItem('i_a', encrypt(String(userData.isAdmin || 0)));
            localStorage.setItem('loginName', userData.full_name || '');
            localStorage.setItem('loginEmail', userData.email || '');
            localStorage.setItem('loginMobile', userData.mobile || '');
            localStorage.setItem('LedCode', userData.id);

            if (rememberMe) {
                localStorage.setItem('rememberedIdentifier', signupIdentifier || '');
            } else {
                localStorage.removeItem('rememberedIdentifier');
            }

            dispatch(setUser({
                id: userData.id,
                rememberMe,
                isAdmin: encrypt(String(userData.isAdmin || 0))
            }));

            setIsLoginModalOpen(false);
            resetSignupOtpState();
            toast.success('Signup complete. Logged in successfully!');
            window.location.reload();
        } catch (err) {
            console.error('Signup OTP verify error:', err);
            setLoginError('Failed to verify OTP');
        }
    };

    const handlePlaceOrder = async () => {
        if (isProcessing) return;
        setIsProcessing(true);

        // toast.error("Coming soon!");
        // return

        if (cartItems.length === 0) {
            toast.error("No items in cart");
            setIsProcessing(false);
            return;
        }

        if (!LedCode && !userId) {
            setIsLoginModalOpen(true);
            setIsProcessing(false);
            return;
        }

        if (!address) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Please add an address to continue");
            setIsProcessing(false);
            return;
        }

        const requiredFields = [
            "name",
            "mobile",
            "address",
            "city",
            "area",
            "pincode",
            "locality",
            "houseNo",
            "district",
            "state",
        ];

        const isIncomplete = requiredFields.some(
            key => address[key] === null || address[key] === undefined || address[key] === ""
        );

        if (isIncomplete) {

            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);
            toast.error("Please complete the address details.");
            setIsProcessing(false);
            return;
        }


        if (!/^[6-9]\d{9}$/.test(address.mobile)) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Enter a valid 10-digit mobile number");
            setIsProcessing(false);
            return;
        }

        if (!/^\d{6}$/.test(address.pincode)) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Enter a valid 6-digit pincode");
            setIsProcessing(false);
            return;
        }


        // check count > 2
        const duplicateFields = [
            "area",
            "buildingName",
            "city",
            "houseNo",
            "landmark",
            "locality"
        ];

        // Collect normalized (trimmed + lowercase) values
        const values = duplicateFields
            .map(key => address[key])
            .filter(val => val && val.trim() !== "")
            .map(val => val.trim().toLowerCase());

        // Count occurrences
        const frequency = values.reduce((acc, val) => {
            acc[val] = (acc[val] || 0) + 1;
            return acc;
        }, {});

        // Check if any value occurs more than 2 times
        const hasExcessiveDuplicates = Object.values(frequency).some(count => count > 2);

        if (hasExcessiveDuplicates) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Address fields contain repeated values. Please refine your address. ");
            setIsProcessing(false);
            return;
        }



        const pinValidation = await checkDelhiveryServiceability(address.pincode);

        setAddress(prev => prev ? ({
            ...prev,
            pre_paid: pinValidation.isPrepaid,
            cod: pinValidation.isCod,
            delhivery_serviceable: pinValidation.serviceable,
            shippingMode: pinValidation.shippingMode   // ✅ ADD THIS
        }) : prev);

        if (!pinValidation.serviceable || !pinValidation.isPrepaid) {
            toast.error(pinValidation.message || "Delivery not available");
            setIsProcessing(false);
            return;
        }

        // Calculate total amount
        const totalAmount = cartItems.reduce(
            (total, item) => total + item.itemPrice * item.quantity,
            0
        );

        // Step 1: Create a Razorpay order on the backend
        try {
            const response = await fetch(`${apiRazorpayUrl}/create-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    amount: totalAmount,
                    currency: "INR",
                    receipt: `order_${Date.now()}`,
                }),
            });

            const order = await response.json();


            const options = {
                key: razorpayCheckoutKey,
                // key: "rzp_test_SIjECOcUjoYoac",
                amount: order.amount,
                currency: order.currency,
                order_id: order.id,
                name: "BLACK BATON",
                description: "Payment for your order",

                handler: async (response) => {

                    const verifyRes = await fetch(`${apiRazorpayUrl}/verify-payment`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature
                        })
                    });

                    const result = await verifyRes.json();

                    if (result.valid) {
                        toast.success("Payment Verified ✅");
                        await placeOrder();
                    } else {
                        toast.error("Payment verification failed ❌");
                        setIsProcessing(false);
                    }
                },

                prefill: {
                    name: address.name,
                    email: address.email,
                    contact: address.mobile,
                },
                theme: { color: "#F37254" },
                modal: {
                    ondismiss: () => {
                        setIsProcessing(false);
                    }
                }
            };



            const rzp = new window.Razorpay(options); // Use global Razorpay object
            rzp.open();

            // Handle payment failure
            rzp.on("payment.failed", async (response) => {
                console.error("Payment failed:", response);
                toast.error("Payment failed, but order will still be processed.");
                setIsProcessing(false);
            });
        } catch (error) {
            console.error("Error creating Razorpay order:", error);
            toast.error("Failed to initiate payment. Please try again.");
            setIsProcessing(false);
        }
    };

    // Function to place the order
    const placeOrder = async () => {
        if (isProcessing && !window.Razorpay) { // If called directly from button, check isProcessing
            if (isProcessing) return;
        }
        setIsProcessing(true);

        if (address?.pincode) {
            const pinValidation = await checkDelhiveryServiceability(address.pincode);
            if (!pinValidation.serviceable) {
                toast.error(pinValidation.message || "Delivery is not available for this address.");
                setIsProcessing(false);
                return;
            }
        }

        if (!address) {
            toast.error("Please add an address to continue");
            setIsProcessing(false);
            return;
        }

        if (!address?.pre_paid) {
            toast.error("Prepaid delivery is not available for this PIN code. Please choose a different address.");
            setIsProcessing(false);
            return;
        }

        const model = "";

        // Format the items array manually as a string with escaped quotes
        const itemsString = cartItems
            .map(
                (item) =>
                    `{\\"id\\":${item.itemId},\\"name\\":\\"${item.itemName}\\",\\"model\\":\\"${model}\\",\\"dp\\":0,\\"mrp\\":${item.itemPrice},\\"quantity\\":${item.quantity},\\"uniqueCode\\":${item.uniqueCode}}`
            )
            .join(","); 

        const currentDate = new Date().toLocaleDateString("en-GB").split("/").reverse().join("-");
        const requestBody = `{"date":"${currentDate}","id":"${LedCode}","contact":"${address.mobile}","items":"[${itemsString}]"}`;

        // console.log(requestBody,'requestBody');

        try {
            // Send the data to the API
            const response = await fetch(`${apiBaseUrl}/orderAdd/BLACKBATON_2526`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: requestBody,
            });

            if (!response.ok) {
                throw new Error("Failed to place order");
            }

            const result = await response.json();

            const orderId = result?.entryNo;
            if (!orderId) {
                throw new Error("Failed to place order");
            }

            // console.log(orderId,'orderId');


            const today = new Date().toISOString().split('T')[0];


            const shipmentPayload = {
                orderId,
                date: today,
                shippingMode: address.shippingMode || "Surface", // ✅ IMPORTANT
                customerAddress: {
                    name: address?.name,
                    address: address?.address,
                    city: address?.city,
                    district: address?.district,
                    state: address?.state,
                    pincode: address?.pincode,
                    mobile: address?.mobile,
                    email: address?.email || "",
                    type: address?.addressType
                },
                cartItems
            };

            let shipmentResult = null;
            const maxShipmentAttempts = 3;
            let shipmentFailureReason = "";
            let isPermanentShipmentFailure = false;

            for (let attempt = 1; attempt <= maxShipmentAttempts; attempt++) {
                try {
                    const shipmentResponse = await fetch(`${apiBaseUrl}/create-delhivery-shipment/BLACKBATON_2526`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(shipmentPayload),
                    });

                    shipmentResult = await shipmentResponse.json();
                    shipmentFailureReason =
                        shipmentResult?.pendingReason ||
                        shipmentResult?.message ||
                        shipmentResult?.error ||
                        "";

                    if (shipmentResponse.ok && shipmentResult?.success && shipmentResult?.awb) {
                        break;
                    }

                    if (!shipmentResponse.ok) {
                        isPermanentShipmentFailure = true;
                        break;
                    }
                } catch (shipmentErr) {
                    console.error(`Shipment attempt ${attempt} failed:`, shipmentErr);
                }

                if (attempt < maxShipmentAttempts) {
                    await new Promise(resolve => setTimeout(resolve, 1200 * attempt));
                }
            }

            if (!shipmentResult?.awb) {
                if (isPermanentShipmentFailure) {
                    console.log(`Payment successful. Order #${orderId} placed, but shipment creation failed. ${shipmentFailureReason || "Please check in dashboard and retry Send To Delhivery."}`);

                    toast.error(`Payment successful. Order #${orderId} placed, but shipment creation failed. ${shipmentFailureReason || "Please check in dashboard and retry Send To Delhivery."}`);
                } else {
                    console.log(`Payment successful. Order #${orderId} is placed, shipment manifest is pending.${shipmentFailureReason ? ` ${shipmentFailureReason}` : ""}`);

                    toast.warning(`Payment successful. Order #${orderId} is placed, shipment manifest is pending.${shipmentFailureReason ? ` ${shipmentFailureReason}` : ""}`);
                }
            }

            handleSubmitWhatsapp({ orderId })

            // Clear the cart after successful order placement
            const clearCartResponse = await fetch(`${apiBaseUrl}/cart/clear/BLACKBATON_2526/${LedCode || userId}`, {
                method: "DELETE",
            });

            if (!clearCartResponse.ok) {
                throw new Error("Failed to clear cart");
            }

            await clearCartResponse.json();
            //("Cart cleared successfully:", clearCartResult);

            // Update the UI by resetting the cart items
            setCartItems([]);

            // Set orderPlaced to true to show the OrderSuccess component
            setOrderPlaced(true);
        } catch (error) {
            console.error("Error placing order:", error);
            toast.error("Failed to place order. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // const placeOrder = async () => {
    //     if (isProcessing && !window.Razorpay) {
    //         if (isProcessing) return;
    //     }

    //     setIsProcessing(true);

    //     console.log("===== PLACE ORDER START =====");

    //     if (!address) {
    //         console.error("Address missing");
    //         toast.error("Please add an address to continue");
    //         setIsProcessing(false);
    //         return;
    //     }

    //     if (!address?.pre_paid) {
    //         console.error("Pincode not prepaid enabled");
    //         toast.error("Prepaid delivery is not available for this PIN code.");
    //         setIsProcessing(false);
    //         return;
    //     }

    //     try {

    //         const model = "";

    //         const itemsArray = cartItems.map((item) => ({
    //             id: item.itemId,
    //             name: item.itemName,
    //             model: model,
    //             dp: 0,
    //             mrp: item.itemPrice,
    //             quantity: item.quantity,
    //             uniqueCode: item.uniqueCode
    //         }));

    //         console.log("Items Array:", itemsArray);

    //         const currentDate = new Date()
    //             .toLocaleDateString("en-GB")
    //             .split("/")
    //             .reverse()
    //             .join("-");

    //         const requestBody = {
    //             date: currentDate,
    //             id: String(LedCode),
    //             contact: address.mobile,
    //             items: JSON.stringify(itemsArray)
    //         };

    //         console.log("Request Body Object:", requestBody);
    //         console.log("Request Body JSON:", JSON.stringify(requestBody));

    //         console.log("API URL:", `${apiBaseUrl}/orderAdd/BLACKBATON_2526`);

    //         const response = await fetch(`${apiBaseUrl}/orderAdd/BLACKBATON_2526`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestBody),
    //         });

    //         console.log("Response Status:", response.status);

    //         const responseText = await response.text();

    //         console.log("Raw Server Response:", responseText);

    //         if (!response.ok) {
    //             console.error("Server returned error:", responseText);
    //             throw new Error(responseText || "Order API failed");
    //         }

    //         let result;

    //         try {
    //             result = JSON.parse(responseText);
    //         } catch (e) {
    //             console.error("JSON parse error:", e);
    //             throw new Error("Invalid JSON returned from server");
    //         }

    //         console.log("Parsed Order Response:", result);

    //         const orderId = result?.entryNo;

    //         console.log("Generated Order ID:", orderId);

    //         const today = new Date().toISOString().split("T")[0];

    //         console.log("Creating Delhivery shipment...");

    //         const shipmentResponse = await fetch(
    //             `${apiBaseUrl}/create-delhivery-shipment/BLACKBATON_2526`,
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify({
    //                     orderId,
    //                     date: today,
    //                     customerAddress: {
    //                         name: address?.name,
    //                         address: address?.address,
    //                         city: address?.city,
    //                         district: address?.district,
    //                         state: address?.state,
    //                         pincode: address?.pincode,
    //                         mobile: address?.mobile,
    //                         email: address?.email || "",
    //                         type: address?.addressType
    //                     },
    //                     cartItems
    //                 })
    //             }
    //         );

    //         console.log("Shipment Response Status:", shipmentResponse.status);

    //         const shipmentText = await shipmentResponse.text();

    //         console.log("Shipment Raw Response:", shipmentText);

    //         let shipmentResult;

    //         try {
    //             shipmentResult = JSON.parse(shipmentText);
    //         } catch (e) {
    //             console.error("Shipment JSON parse error:", e);
    //         }

    //         console.log("Shipment Result:", shipmentResult);

    //         if (!shipmentResponse.ok || !shipmentResult?.success) {
    //             console.warn("Shipment creation failed:", shipmentResult?.message);
    //         }

    //         console.log("Sending WhatsApp message...");
    //         handleSubmitWhatsapp();

    //         console.log("Clearing cart...");

    //         const clearCartResponse = await fetch(
    //             `${apiBaseUrl}/cart/clear/BLACKBATON_2526/${LedCode || userId}`,
    //             {
    //                 method: "DELETE"
    //             }
    //         );

    //         console.log("Clear Cart Status:", clearCartResponse.status);

    //         const clearCartText = await clearCartResponse.text();

    //         console.log("Clear Cart Response:", clearCartText);

    //         setCartItems([]);

    //         setOrderPlaced(true);

    //         console.log("===== ORDER SUCCESS =====");

    //     } catch (error) {

    //         console.error("===== ORDER FAILED =====");
    //         console.error("Error details:", error);

    //         toast.error("Failed to place order. Please try again.");

    //     } finally {
    //         setIsProcessing(false);
    //     }
    // };

    const handleDeleteItem = async (itemId, ledcode, uniqueCode) => {
        if (!LedCode && !userId) {
            // Guest User delete
            const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
            const updatedGuestCart = guestCart.filter(item => item.uniqueCode !== uniqueCode);
            localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
            setCartItems(updatedGuestCart);
            toast.success('Item deleted successfully');
            return;
        }

        try {
            const response = await fetch(`${apiBaseUrl}/cart/item/BLACKBATON_2526/${itemId}/${ledcode}/${uniqueCode}`, {
                method: 'DELETE',
            });

            const data = await response.json();

            if (response.ok) {
                toast.info('Item deleted successfully');
                // Refresh the cart or remove the item from state
                setCartItems((prevItems) => prevItems.filter(item => item.uniqueCode !== uniqueCode));
            } else {
                toast.info(data.message || 'Failed to delete item');
            }
        } catch (error) {
            console.error('Error deleting item:', error);
            toast.info('Error deleting item');
        }
    };




    return (
        <div className='min-h-screen flex flex-col' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}
            {/* Order Success Modal */}
            {orderPlaced && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <OrderSuccess onClose={() => setOrderPlaced(false)} />
                </div>
            )}
            {cartItems.length > 0 && (
                < div
                    className={`h-[56px] ${isProcessing ? 'bg-gray-500 cursor-not-allowed' : 'bg-[black] cursor-pointer'} justify-center lg:hidden flex items-center fixed bottom-0 left-0 w-full text-base font-[600] font-montserrat text-[white]`}
                    // onClick={!isProcessing ? placeOrder : null}
                onClick={!isProcessing ? handlePlaceOrder : null}
                >
                    {isProcessing ? 'Processing...' : (!LedCode && !userId) ? 'Login' : 'Place Order'}
                </div>
            )}
            <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] mt-[60px] lg:pb-12 pb-6'>
                <span className='lg:text-2xl text-lg font-[700] font-montserrat text-left'>Shopping Bag</span>
                <div className='w-full flex lg:flex-row flex-col gap-8 lg:pb-12 pb-6'>
                    <div className='lg:w-[70%] w-full h-auto flex flex-col gap-3'>
                        <div className={`rounded-[5px] lg:h-[58px] h-auto border-2 ${addError ? 'border-[#eb0000]' : 'border-[#EAEAEC]'} justify-between flex lg:flex-row flex-row lg:items-center items-start lg:py-0 py-3 lg:px-5 px-1 lg:gap-0 gap-3`}>
                            <span className='lg:text-sm text-xs font-[400] font-montserrat text-left'>
                                Deliver to:&nbsp;&nbsp;&nbsp;
                                {address ? `${address.name}, ${address.address}, ${address.city}` : 'No address Selected'}
                            </span>
                            <span
                                className={`lg:w-[10%] w-[30%] h-[30px] border-2 ${!address ? 'border-[red]' : 'border-[black]'
                                    } rounded-[3.51px] flex justify-center items-center lg:text-sm text-xs font-[400] font-montserrat cursor-pointer`}
                                onClick={addresspage}
                            >
                                Add
                            </span>
                        </div>

                        {cartItems.length === 0 ? (
                            <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 rounded-md shadow-md p-6">
                                <span className="text-lg font-semibold text-gray-700">Your cart is empty</span>
                                <p className="text-sm text-gray-500">Add items to your cart to see them here.</p>
                            </div>
                        ) : (
                            cartItems.map((item, idx) => {

                                const color = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || [];
                                const code = `${item.itemId}_${color}`
                                const modifiedColor = modifiedColors[color]?.name

                                return (
                                    <div key={idx} className='rounded-[5px] h-auto lg:px-5 px-1 py-5 border-2 border-[#EAEAEC] justify-between flex lg:flex-row flex-col'>
                                        <div className='flex flex-row h-[115px] gap-5 items-center'>
                                            <div className='h-full w-[90px] bg-[white] rounded-[5px] p-3'>
                                                <img
                                                    src={`${apiLocalUrl}/uploads/${code}.webp`}
                                                    alt={item.itemName}
                                                    style={{ width: '100%', height: '100%', mixBlendMode: 'multiply' }}
                                                />
                                            </div>
                                            <div className='h-full flex flex-col gap-2'>
                                                <span
                                                    className='lg:text-base text-left text-sm font-[600] font-montserrat cursor-pointer hover:underline'
                                                    onClick={() => openProductFromCart(item)}
                                                >
                                                    {item.itemName} [{modifiedColor || color}]
                                                </span>
                                                <span className='text-sm font-[400] font-montserrat text-left'>Qty: {item.quantity}</span>
                                                <span className='text-lg font-[600] font-montserrat text-left'>₹{item.itemPrice}</span>
                                                <span className='text-lg font-[600] font-montserrat text-left'>

                                                    <div
                                                        style={{
                                                            display: 'inline-block',
                                                            width: '16px',
                                                            height: '16px',
                                                            borderRadius: '50%',
                                                            backgroundColor: color || 'transparent',
                                                            border: color ? '1px solid #ccc' : 'none',

                                                            verticalAlign: 'middle',
                                                        }}
                                                    />
                                                    &nbsp;  {productDetails[item.uniqueCode]?.size || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className='flex flex-col gap-3 items-end '>
                                            {/* <span className='text-sm font-[400] font-montserrat'>Delivery by Sat Dec 28</span> */}
                                            <div className='w-max p-2 h-[36px] border-2 border-[#EAEAEC] rounded-[32px] flex flex-row justify-center items-center gap-3 '>
                                                <span
                                                    className='p-2 font-[500] text-sm font-montserrat cursor-pointer'
                                                    onClick={() => handleQuantityChange(item.sino || item.uniqueCode, item.quantity - 1)}
                                                >
                                                    -
                                                </span>
                                                <span className='font-[500] text-xl font-montserrat'>{item.quantity}</span>
                                                <span
                                                    className='p-2 font-[500] text-sm font-montserrat cursor-pointer'
                                                    onClick={() => handleQuantityChange(item.sino || item.uniqueCode, item.quantity + 1)}
                                                >
                                                    +
                                                </span>

                                            </div>

                                            <img
                                                src={deleteicon}
                                                alt="deleteicon"
                                                className='cursor-pointer'
                                                onClick={() => handleDeleteItem(item.itemId, item.ledcode, item.uniqueCode)}
                                            />


                                        </div>
                                    </div>
                                )
                            })
                        )}

                        <div className='rounded-[5px] h-[60px] border-2 border-[#EAEAEC] justify-between flex items-center lg:px-5 px-1 cursor-pointer' onClick={wishlistpage}>
                            <span className='text-sm font-[400] font-montserrat'>Add More From Wishlist</span>
                        </div>

                        {cartItems.length > 0 && (
                            <div className='rounded-[5px] h-auto min-h-[100px] border-2 border-[#EAEAEC] justify-between lg:flex hidden items-center lg:px-5 px-4 py-4 gap-4'>
                                <div className='w-[65%] flex flex-col text-left gap-2'>
                                    <span className='text-sm font-[500] font-montserrat text-[#3d3d3d]'>
                                        Receive order notifications through email
                                    </span>
                                    {/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(registeredEmail || '').trim()) ? (
                                        <span className='text-sm font-[600] font-montserrat text-black'>
                                            {registeredEmail}
                                        </span>
                                    ) : (
                                        <div className='flex flex-col gap-2'>
                                            <span className='text-sm font-[500] font-montserrat text-[#B42318]'>
                                                Provide email to receive order confirmation and tracking updates.
                                            </span>
                                            {!emailEditorOpen ? (
                                                <button
                                                    type="button"
                                                    className='w-max h-[32px] px-3 rounded-[4px] border border-black text-xs font-[600] font-montserrat'
                                                    onClick={() => setEmailEditorOpen(true)}
                                                >
                                                    Update Email
                                                </button>
                                            ) : (
                                                <div className='flex flex-col gap-2'>
                                                    <div className='flex items-center gap-2'>
                                                        <input
                                                            type='email'
                                                            value={newEmailInput}
                                                            onChange={(e) => setNewEmailInput(e.target.value)}
                                                            placeholder='Enter your email'
                                                            className='h-[34px] px-3 border border-[#D0D5DD] rounded-[4px] text-sm w-[260px]'
                                                        />
                                                        <button
                                                            type='button'
                                                            onClick={handleSendEmailOtp}
                                                            disabled={emailUpdateLoading}
                                                            className='h-[34px] px-3 bg-black text-white rounded-[4px] text-xs font-[600]'
                                                        >
                                                            {emailUpdateLoading ? 'Sending...' : 'Send OTP'}
                                                        </button>
                                                    </div>
                                                    {emailOtpSent && (
                                                        <div className='flex items-center gap-2'>
                                                            <input
                                                                type='text'
                                                                value={emailOtpInput}
                                                                onChange={(e) => setEmailOtpInput(e.target.value)}
                                                                placeholder='Enter OTP'
                                                                className='h-[34px] px-3 border border-[#D0D5DD] rounded-[4px] text-sm w-[160px]'
                                                            />
                                                            <button
                                                                type='button'
                                                                onClick={handleVerifyEmailOtp}
                                                                disabled={emailUpdateLoading}
                                                                className='h-[34px] px-3 bg-black text-white rounded-[4px] text-xs font-[600]'
                                                            >
                                                                {emailUpdateLoading ? 'Verifying...' : 'Verify & Save'}
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <button
                                    className={`h-[50px] w-[30%] ${isProcessing ? 'bg-gray-500 cursor-not-allowed' : 'bg-[black] cursor-pointer'} rounded-[5px] flex justify-center items-center text-base font-[500] font-montserrat text-[white]`}
                                    // onClick={placeOrder}
                                    onClick={handlePlaceOrder}

                                    disabled={isProcessing}
                                >
                                    {isProcessing ? 'Processing...' : (!LedCode && !userId) ? 'Login' : 'Place Order'}
                                </button>
                            </div>
                        )}

                        {cartItems.length > 0 && (
                            <div className='rounded-[5px] h-auto border-2 border-[#EAEAEC] lg:hidden flex flex-col px-3 py-3 gap-2'>
                                <span className='text-sm font-[500] font-montserrat text-[#3d3d3d] text-left'>
                                    Receive order notifications through email
                                </span>
                                {/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(registeredEmail || '').trim()) ? (
                                    <span className='text-sm font-[600] font-montserrat text-black text-left'>
                                        {registeredEmail}
                                    </span>
                                ) : (
                                    <div className='flex flex-col gap-2'>
                                        <span className='text-xs font-[500] font-montserrat text-[#B42318] text-left'>
                                            Provide email to receive order confirmation and tracking updates.
                                        </span>
                                        {!emailEditorOpen ? (
                                            <button
                                                type="button"
                                                className='w-max h-[32px] px-3 rounded-[4px] border border-black text-xs font-[600] font-montserrat'
                                                onClick={() => setEmailEditorOpen(true)}
                                            >
                                                Update Email
                                            </button>
                                        ) : (
                                            <div className='flex flex-col gap-2'>
                                                <input
                                                    type='email'
                                                    value={newEmailInput}
                                                    onChange={(e) => setNewEmailInput(e.target.value)}
                                                    placeholder='Enter your email'
                                                    className='h-[34px] px-3 border border-[#D0D5DD] rounded-[4px] text-sm w-full'
                                                />
                                                <button
                                                    type='button'
                                                    onClick={handleSendEmailOtp}
                                                    disabled={emailUpdateLoading}
                                                    className='h-[34px] px-3 bg-black text-white rounded-[4px] text-xs font-[600] w-max'
                                                >
                                                    {emailUpdateLoading ? 'Sending...' : 'Send OTP'}
                                                </button>
                                                {emailOtpSent && (
                                                    <div className='flex flex-col gap-2'>
                                                        <input
                                                            type='text'
                                                            value={emailOtpInput}
                                                            onChange={(e) => setEmailOtpInput(e.target.value)}
                                                            placeholder='Enter OTP'
                                                            className='h-[34px] px-3 border border-[#D0D5DD] rounded-[4px] text-sm w-full'
                                                        />
                                                        <button
                                                            type='button'
                                                            onClick={handleVerifyEmailOtp}
                                                            disabled={emailUpdateLoading}
                                                            className='h-[34px] px-3 bg-black text-white rounded-[4px] text-xs font-[600] w-max'
                                                        >
                                                            {emailUpdateLoading ? 'Verifying...' : 'Verify & Save'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className='lg:w-[30%] w-full h-[321px] flex flex-col rounded-[2px] border-2 border-[#EAEAEC] lg:mb-0 mb-[25%]'>
                        <div className='w-full h-[18%] border-b-2 border-[#EAEAEC] px-3 flex justify-between items-center text-base font-[600] font-montserrat'>
                            Price Details
                        </div>
                        <div className='w-full h-[82%] flex flex-col px-3 gap-5'>
                            <ul className='border-2 border-black mt-5 text-[#F0F0F0]' />
                            <div className='flex flex-col gap-5 w-full'>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Price ({cartItems.length} items)</span>
                                    <span className='text-base font-[600] font-montserrat'>
                                        ₹{cartItems.reduce((total, item) => total + item.itemPrice * item.quantity, 0)}
                                    </span>
                                </div>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Discount</span>
                                    <span className='text-base font-[600] font-montserrat'></span>
                                </div>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Delivery Charges</span>
                                    <span className='text-base font-[600] font-montserrat'>₹00.00</span>
                                </div>
                            </div>
                            <ul className='border-b-2 border-black border-dashed' />
                            <div className='w-full flex justify-between'>
                                <span className='text-base font-[600] font-montserrat'>Total Amount</span>
                                <span className='text-base font-[600] font-montserrat'>
                                    ₹{cartItems.reduce((total, item) => total + item.itemPrice * item.quantity, 0)}
                                </span>
                            </div>
                            <ul className='border-b-2 border-black border-dashed' />
                        </div>
                    </div>
                </div>
            </div>
            <div className='lg:flex hidden'>{isMobile ? <FooterMob /> : <Footer />}</div>
            <ToastContainer position="top-right" autoClose={3000} />

            {/* Login Modal */}
            {isLoginModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-[100] p-3 md:p-4">
                    <div className="w-full max-w-2xl overflow-hidden rounded-[28px] shadow-2xl bg-white border border-white/30">
                        <div className="grid md:grid-cols-5 grid-cols-1">
                            {/* Left panel: login methods */}
                            <div className="md:block hidden col-span-2 bg-slate-900 border-r border-slate-800 p-8">
                                <div className="flex flex-col justify-center items-center gap-3 text-white/90 mb-6">
                                    {/* <p className="text-xs uppercase tracking-[0.3em] text-teal-200">Login Method</p> */}
                                    {/* <h3 className="text-2xl font-black font-montserrat leading-tight">Choose Option</h3> */}
                                    <img src={logo} alt="" className='invert w-max h-12' />
                                </div>
                                <div className="flex flex-col gap-3">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (authTab === 'login') {
                                                setLoginMode('password');
                                            } else {
                                                setSignupMode('email');
                                                resetSignupOtpState();
                                            }
                                            setLoginError('');
                                        }}
                                        className={`w-full text-left rounded-2xl border px-4 py-4 text-sm font-bold uppercase tracking-wider transition-all ${((authTab === 'login' && loginMode === 'password') || (authTab === 'signup' && signupMode === 'email')) ? 'bg-white text-black border-white' : 'bg-slate-800 text-white border-slate-700 hover:bg-slate-700'}`}
                                    >
                                        Email
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (authTab === 'login') {
                                                setLoginMode('otp');
                                            } else {
                                                setSignupMode('mobile');
                                                resetSignupOtpState();
                                            }
                                            setLoginError('');
                                        }}
                                        className={`w-full text-left rounded-2xl border px-4 py-4 text-sm font-bold uppercase tracking-wider transition-all ${((authTab === 'login' && loginMode === 'otp') || (authTab === 'signup' && signupMode === 'mobile')) ? 'bg-white text-black border-white' : 'bg-slate-800 text-white border-slate-700 hover:bg-slate-700'}`}
                                    >
                                        Mobile
                                    </button>
                                </div>
                            </div>

                            {/* Form panel */}
                            <div className="col-span-3 bg-white px-5 md:px-8 py-6 md:py-10">
                                <div className="flex justify-between items-start mb-5 md:mb-6">
                                    <div>
                                        {/* <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.25em] text-gray-400">Checkout Access</p> */}
                                        <h2 className="text-2xl md:text-2xl font-extrabold font-montserrat text-gray-900 mt-1">{authTab === 'login' ? 'Login' : 'Sign up'}</h2>
                                    </div>
                                    <button
                                        onClick={() => { setIsLoginModalOpen(false); resetSignupOtpState(); }}
                                        className="w-9 h-9 rounded-full bg-gray-100 text-gray-500 hover:text-black hover:bg-gray-200 transition-colors flex items-center justify-center"
                                        aria-label="Close login modal"
                                        type="button"
                                    >
                                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M18 6L6 18" />
                                            <path d="M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Mobile method switch (left panel is hidden on mobile) */}
                                <div className="md:hidden grid grid-cols-2 gap-2 mb-5 p-1 rounded-2xl bg-gray-100">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (authTab === 'login') {
                                                setLoginMode('password');
                                            } else {
                                                setSignupMode('email');
                                                resetSignupOtpState();
                                            }
                                            setLoginError('');
                                        }}
                                        className={`px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-widest transition-all ${((authTab === 'login' && loginMode === 'password') || (authTab === 'signup' && signupMode === 'email')) ? 'bg-black text-white shadow-lg shadow-black/25' : 'bg-transparent text-gray-600'}`}
                                    >
                                        Email
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (authTab === 'login') {
                                                setLoginMode('otp');
                                            } else {
                                                setSignupMode('mobile');
                                                resetSignupOtpState();
                                            }
                                            setLoginError('');
                                        }}
                                        className={`px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-widest transition-all ${((authTab === 'login' && loginMode === 'otp') || (authTab === 'signup' && signupMode === 'mobile')) ? 'bg-black text-white shadow-lg shadow-black/25' : 'bg-transparent text-gray-600'}`}
                                    >
                                        Mobile
                                    </button>
                                </div>

                                {authTab === 'login' ? (
                                    <form onSubmit={handleModalLogin} className="space-y-4 md:space-y-6">

                                        {loginMode === 'password' ? (
                                            <>
                                                <div className="space-y-2">
                                                    <label className="text-sm font-semibold font-montserrat block">Email / Mobile</label>
                                                    <input
                                                        type="text"
                                                        className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                        placeholder="Enter your email or mobile"
                                                        value={loginEmail}
                                                        onChange={(e) => setLoginEmail(e.target.value)}
                                                    />
                                                </div>

                                                <div className="space-y-2">
                                                    <label className="text-sm font-semibold font-montserrat block">Password</label>
                                                    <div className="relative">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                            placeholder="Enter your password"
                                                            value={loginPassword}
                                                            onChange={(e) => setLoginPassword(e.target.value)}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-black"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        >
                                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="space-y-2">
                                                    <label className="text-sm font-semibold font-montserrat block">Mobile Number</label>
                                                    <input
                                                        type="tel"
                                                        className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                        placeholder="Enter 10-digit mobile number"
                                                        value={loginMobile}
                                                        onChange={(e) => setLoginMobile(e.target.value)}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={handleSendModalLoginOtp}
                                                        className="w-full h-11 rounded-xl bg-gradient-to-r from-gray-900 to-black text-white font-bold shadow-lg shadow-black/20 active:scale-[0.99] transition-all"
                                                    >
                                                        Send OTP
                                                    </button>
                                                    {loginOtpStatus && <p className="text-green-600 text-sm font-medium">{loginOtpStatus}</p>}
                                                </div>
                                                {loginOtpSession && (
                                                    <div className="space-y-2">
                                                        <label className="text-sm font-semibold font-montserrat block">Enter OTP</label>
                                                        <input
                                                            type="text"
                                                            className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                            placeholder="6-digit OTP"
                                                            value={loginOtp}
                                                            onChange={(e) => setLoginOtp(e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {/* <div className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                id="rememberModal"
                                                className="w-4 h-4 rounded border-gray-300 text-black focus:ring-black"
                                                checked={rememberMe}
                                                onChange={() => setRememberMe(!rememberMe)}
                                            />
                                            <label htmlFor="rememberModal" className="text-sm font-medium font-montserrat cursor-pointer">
                                                Remember me
                                            </label>
                                        </div> */}

                                        {loginError && (
                                            <p className="text-red-500 text-sm font-medium bg-red-50 p-3 rounded-lg border border-red-100">
                                                {loginError}
                                            </p>
                                        )}

                                        {loginMode === 'password' ? (
                                            <button
                                                type="button"
                                                className={`w-full py-3 px-4 md:py-4  text-white rounded-xl font-bold font-montserrat hover:brightness-110 transition-all transform active:scale-95 shadow-xl flex items-center justify-center gap-2 bg-gradient-to-r from-black via-gray-900 to-black`}
                                                onClick={loginMode === 'password' ? handleModalLogin : handleVerifyModalLoginOtp}
                                            >
                                                Proceed to Checkout
                                            </button>
                                        ) : loginOtpSession && (
                                            <button
                                                type="button"
                                                className={`w-full py-3 px-4 md:py-4  text-white rounded-xl font-bold font-montserrat hover:brightness-110 transition-all transform active:scale-95 shadow-xl flex items-center justify-center gap-2 ${!loginOtpSession ? 'bg-gray-600' : 'bg-gradient-to-r from-black via-gray-900 to-black'}`}
                                                onClick={loginMode === 'password' ? handleModalLogin : handleVerifyModalLoginOtp}
                                            >
                                                Proceed to Checkout
                                            </button>
                                        )}

                                        <p className="text-sm text-gray-500 text-center">
                                            Don't have an account?{' '}
                                            <button
                                                type="button"
                                                className="text-black font-bold underline hover:text-gray-700"
                                                onClick={() => { setAuthTab('signup'); resetSignupOtpState(); setLoginError(''); }}
                                            >
                                                Sign up
                                            </button>
                                        </p>
                                    </form>
                                ) : (
                                    <div className="space-y-4">
                                        {!signupIsOtpStep ? (
                                            <>
                                                <div className="space-y-2">
                                                    <label className="text-sm font-semibold font-montserrat block">{signupMode === 'email' ? 'Email / Mobile' : 'Mobile Number'}</label>
                                                    <input
                                                        type={signupMode === 'email' ? 'text' : 'tel'}
                                                        className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                        placeholder={signupMode === 'email' ? 'Enter your email or mobile' : 'Enter 10-digit mobile'}
                                                        value={signupMode === 'email' ? signupEmail : signupMobile}
                                                        onChange={(e) => signupMode === 'email' ? setSignupEmail(e.target.value) : setSignupMobile(e.target.value)}
                                                    />
                                                </div>

                                                {signupMode === 'email' && (
                                                    <>
                                                        <div className="space-y-2">
                                                            <label className="text-sm font-semibold font-montserrat block">Full Name</label>
                                                            <input
                                                                type="text"
                                                                className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                                placeholder="Enter your full name"
                                                                value={signupName}
                                                                onChange={(e) => setSignupName(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="space-y-2">
                                                            <label className="text-sm font-semibold font-montserrat block">Password</label>
                                                            <input
                                                                type="password"
                                                                className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                                placeholder="Create your password"
                                                                value={signupPassword}
                                                                onChange={(e) => setSignupPassword(e.target.value)}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <div className="space-y-2">
                                                <label className="text-sm font-semibold font-montserrat block">Enter OTP</label>
                                                <input
                                                    type="text"
                                                    className="w-full h-12 rounded-xl px-4 bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-black outline-none transition-all"
                                                    placeholder="6-digit OTP"
                                                    value={signupOtp}
                                                    onChange={(e) => setSignupOtp(e.target.value)}
                                                />
                                                {signupOtpStatus && <p className="text-green-600 text-sm font-medium">{signupOtpStatus}</p>}
                                            </div>
                                        )}

                                        {loginError && (
                                            <p className="text-red-500 text-sm font-medium bg-red-50 p-3 rounded-lg border border-red-100">
                                                {loginError}
                                            </p>
                                        )}

                                        <button
                                            type="button"
                                            className="w-full h-13 p-3 md:h-14 bg-gradient-to-r from-black via-gray-900 to-black text-white rounded-xl font-bold font-montserrat hover:brightness-110 transition-all transform active:scale-95 shadow-xl flex items-center justify-center gap-2"
                                            onClick={signupIsOtpStep ? handleVerifyInlineSignupOtp : handleInlineSignup}
                                            disabled={signupLoading}
                                        >
                                            {signupIsOtpStep ? 'Verify & Login' : (signupLoading ? 'Sending OTP...' : 'Create & Verify')}
                                        </button>

                                        <p className="text-sm text-gray-500 text-center">
                                            Already have an account?{' '}
                                            <button
                                                type="button"
                                                className="text-black font-bold underline hover:text-gray-700"
                                                onClick={() => { setAuthTab('login'); resetSignupOtpState(); setLoginError(''); }}
                                            >
                                                Login
                                            </button>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
}

export default Cart;

